import {
  SMSAddress,
  SMSCurrency,
  SMSLanguage,
  SMSSalutationDTO,
  SMSUser,
} from '@dh-io-emh/commerce-api/src/models/shared/ocb/api.schema';

export default class User implements SMSUser {
  authByEmail: boolean;
  currency: SMSCurrency;
  customerId: string;
  deactivationDate: string;
  defaultAddress: SMSAddress;
  deliveryOption: 'USE_BILLING_ADDRESS' | 'USE_DEFAULT_DELIVERY_ADDRESS';
  displayUid: string;
  email: string;
  firstName: string;
  language: SMSLanguage;
  lastName: string;
  lastName2: string;
  mobile: string;
  name: string;
  privacyStatementEmail: boolean;
  privacyStatementMail: boolean;
  privacyStatementPhone: boolean;
  salutation: SMSSalutationDTO;
  title: string;
  titleCode: string;
  uid: string;
  verified: boolean;

  static create(data: SMSUser) {
    return Object.assign(new User(), data);
  }

  get fullName() {
    return `${this.firstName} ${this.lastName}`;
  }
}
